export const quiz = state => {
	return state.quiz;
};

export const profile = state => {
	return state.profile;
};

export const regimenElements = state => {
	return state.regimenElements;
};

export const allRegimenElements = state => {
	return state.allRegimenElements;
};

export const userRegimenElements = state => {
	return state.userRegimenElements;
};

export const notes = state => {
	return state.notes;
};

export const insights = state => {
	return state.insights;
};


// WEBPACK FOOTER //
// ./src/store/modules/quiz/getters.js